
      import { defineNuxtPlugin } from '#imports'
      import { vTooltip, vClosePopper } from 'floating-vue'
      
      export default defineNuxtPlugin((nuxtApp) => { 
        nuxtApp.vueApp.directive('tooltip', vTooltip)
        nuxtApp.vueApp.directive('close-popper', vClosePopper)
      })
    